import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';

import { useAppSelector } from '@app/core/hooks';
import { useCpmsBoGetChargePointQuery } from '@app/core/service/cpms-bo-charge-point.service';
import { cpmsBoChargePointSlice } from '@app/core/service/cpms-bo-charge-point.slice';

export interface ChargePointFilterStateControllerProps {
  value: GatewayChargePointModel['id'];
  onRemove: FilteredItemProps['onRemove'];
}

export const ChargePointFilterStateController = ({
  value,
  onRemove,
}: ChargePointFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const chargePoint = useAppSelector((state) =>
    cpmsBoChargePointSlice.selectors.selectById(state, value),
  );

  const { data: chargePointApiData } = useCpmsBoGetChargePointQuery(value, {
    skip: !!chargePoint,
  });

  const chargePointName = chargePoint?.name ?? chargePointApiData?.name ?? '';

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="electric-terminal"
      label={chargePointName}
      onRemove={onRemove}
    />
  );
};
